/**
 * Diz, sem rodeio, que os números da tela não vieram do sistema.
 *
 * <p><b>Este aviso é a camada FRACA da proteção, e é bom saber disso.</b> Ele
 * some com uma regra de CSS, com um recorte de captura de tela, com uma
 * impressão mal configurada.
 *
 * <p>A camada que vale é estrutural: em {@code operacao_assistida} e
 * {@code producao} os dados de exemplo <b>não são retornados</b> — ver
 * {@code dadosDeExemplo.ts}. Quando o ambiente passar a receber dado real, a
 * tela para de inventar sozinha, e ninguém precisa lembrar de desligar nada.
 */
export function AvisoDeExemplo() {
  return (
    <div className="ui-aviso-exemplo" role="note">
      <strong>Dados de exemplo</strong>
      <span>
        Nenhum número desta tela veio do sistema. Eles existem para desenhar o
        painel — e desaparecem sozinhos quando o ambiente passar a receber dado
        real.
      </span>
    </div>
  );
}
